import React from "react";
import { useTheme } from "@mui/material";
import InactiveStars from "./inactive-stars";
import InactiveSunshine from "./inactive-sunshine";
import { useInactivity } from "../../../../hooks/useInactivity"; // Adjust path as needed

export default function InactiveBackground() {
    const theme = useTheme();
    // Use 15 seconds (15000ms) for inactivity timeout
    const isActive = useInactivity(15000);
    const isDarkMode = theme.palette.mode === 'dark';

    return (
        <>
            {isDarkMode ? (
                <InactiveStars isActive={isActive} />
            ) : (
                <InactiveSunshine isActive={isActive} />
            )}
        </>
    );
}
